import { useEffect, useState } from "react";



const ReactRating = ({ onRate, rate, isEnabled }) => {

    const [hoveredStar, setHoveredStar] = useState(-1);
    const [selectedRating, setSelectedRating] = useState(-1);
    const [wholeHover, setWholeHover] = useState(false);

    useEffect(() => {
        setSelectedRating(rate - 1);
        setHoveredStar(rate - 1);
    }, [rate])

    const displayCondition = (i) => (isEnabled && i === hoveredStar) || (wholeHover && i === (rate - 1));

    return (
        <div style={{ zIndex: 99 }}>
            <div onMouseEnter={() => { if (!isEnabled) { setWholeHover(true) } }} onMouseLeave={() => { if (isEnabled) { if (selectedRating === -1) { setHoveredStar(-1); } else { setHoveredStar(selectedRating); } } else { setWholeHover(false); } }} style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                {[...Array(5)].map((_, i) => {
                    return (
                        <div className="rate-star" key={i} onClick={() => { if (isEnabled) { onRate(i + 1); setSelectedRating(i); } }} onMouseEnter={() => { isEnabled && setHoveredStar(i); }} style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 20, width: 20, cursor: isEnabled ? "pointer" : "default", position: "relative", marginRight: 5, zIndex: 1 }}>
                            <div style={{ pointerEvents: "none", position: "absolute", opacity: displayCondition(i) ? 1 : 0, top: i === hoveredStar ? "-155%" : "-100%", left: "-24%", transition: "0.5s" }}>
                                <RateContainer />
                                <p style={{ color: "#fff", position: "absolute", top: "30%", left: "70%", transform: "translate(-50%,-50%)" }}>{i + 1}</p>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 214.43 204.66">
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="Layer_1-2" data-name="Layer 1">
                                        <path style={{ fill: i <= hoveredStar ? "#ffae00" : "#fff", stroke: i <= hoveredStar ? "#ffae00" : "#231520", strokeMiterlimit: 10, strokeWidth: 2, transition: "0.5s all" }} className="cls-1" d="M113.48,4.27l27.6,55.93A7,7,0,0,0,146.34,64l61.72,9a7,7,0,0,1,3.88,11.92l-44.67,43.53a7,7,0,0,0-2,6.19l10.54,61.47a7,7,0,0,1-10.14,7.36l-55.2-29a7,7,0,0,0-6.51,0l-55.2,29a7,7,0,0,1-10.14-7.36l10.54-61.47a7,7,0,0,0-2-6.19L2.49,84.91A7,7,0,0,1,6.36,73l61.73-9a7,7,0,0,0,5.26-3.82L101,4.27A7,7,0,0,1,113.48,4.27Z" />
                                    </g>
                                </g>
                            </svg>
                        </div>
                    );
                })}
            </div>
        </div>

    );
}

export default ReactRating;


const RateContainer = () => {
    return (
        <div style={{ height: 30, width: 20 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 178.45 237.9">
                <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1"><path style={{ fill: "#000000", stroke: "#231520", strokeMiterlimit: 10, strokeWidth: 2 }} className="cls-1" d="M163.78.38H14.67A14.29,14.29,0,0,0,.38,14.67V163.78a14.29,14.29,0,0,0,14.29,14.3H55.54L83,233.63a7,7,0,0,0,12.53,0l27.42-55.55h40.87a14.3,14.3,0,0,0,14.3-14.3V14.67A14.29,14.29,0,0,0,163.78.38Z" />
                    </g>
                </g>
            </svg>
        </div>
    );
}

